import React from "react";
import styles from "../../styles/game-shot-charts.widget.module.scss";
import classNames from "classnames";
import {observer} from "mobx-react";
import {GAME_SHOT_CHARTS} from "../../game-shot-charts.widget.consts";
import {EntityLogo} from "../../../../core/components/logos/entity-logo";
import {GameShotChartWidgetSelectorPlayerDetails} from "./game-shot-chart.widget.selector.player-details";

export const GameShotChartWidgetSelectorPlayer = observer(({controller, selectedShot, isShallowShotMapView}) => {
  if(selectedShot === null) {
    return null;
  }

  const {state} = controller;
  const {device: {isSmallView}} = controller;
  const {game, sportTypeId, isWidget} = state;
  const {player, gameId, outcomeAnalyticValue} = selectedShot;

  const containerProps = {
    className: classNames(styles.selector_player, {[styles.clickable]: !isWidget}),
    onClick: !isWidget ? () => {
      controller.action(GAME_SHOT_CHARTS.ACTION_TYPES.onPlayerPopupClick, {isVisible: true})
      controller.action(GAME_SHOT_CHARTS.ANALYTICS.ACTION_TYPES.onPlayerClick, {
        gameId,
        athleteId: player.athleteId,
        competitorId: player.competitorId,
        competitionId: game.competitionId,
        status: game.statusGroup,
        sportTypeId,
        outcome: outcomeAnalyticValue
      })
    } : null
  }

  const logoProps = {
    entity: player,
    className: classNames(styles.selector_player_logo),
    width: isShallowShotMapView && !isSmallView ? GAME_SHOT_CHARTS.SHALLOW_SHOT_MAP_PLAYER_LOGO_SIZE : GAME_SHOT_CHARTS.SELECTOR_PLAYER_LOGO_SIZE,
    height: isShallowShotMapView && !isSmallView ? GAME_SHOT_CHARTS.SHALLOW_SHOT_MAP_PLAYER_LOGO_SIZE : GAME_SHOT_CHARTS.SELECTOR_PLAYER_LOGO_SIZE
  }

  return (
    <div {...containerProps}>
      <div className = {classNames(styles.selector_player_logo_container)}>
        <EntityLogo {...logoProps}/>
      </div>
      <GameShotChartWidgetSelectorPlayerDetails selectedShot={selectedShot} isShallowShotMapView={isShallowShotMapView}/>
    </div>
  )
});